<template>
    <inter-modal title-icon="flaticon-key"
                 :buttonPrimary="buttonPrimary"
                 title="Cambia Password"
                 :visible="showModal"
                 :no-close-on-backdrop="false"
                 size="sm"
                 @onPrimaryClick="updatePassword()">
        <b-container fluid>
            <b-row>
                <b-col cols="12">
                    <inter-input class="mb-3"
                                 label="Vecchia Password"
                                 v-model="passwords.old"
                                 icon="key"
                                 type="password"
                                 :error="errors.old">
                    </inter-input>
                </b-col>
                <b-col cols="12">
                    <inter-input class="mb-3"
                                 label="Nuova Password"
                                 v-model="passwords.new"
                                 type="password"
                                 icon="key"
                                 :error="errors.new">
                    </inter-input>
                </b-col>
                <b-col cols="12">
                    <inter-input
                            label="Conferma Password"
                            v-model="passwords.confirm"
                            type="password"
                            icon="key"
                            :error="errors.confirm">
                    </inter-input>
                </b-col>
            </b-row>
        </b-container>
    </inter-modal>
</template>

<script>
    import InterInput from "../form/inter-input/InterInput";
    import InterModal from "../modal/InterModal";
    import {mapActions} from 'vuex';
    import _ from "lodash";

    export default {
        name: "ModalUpdatePassword",
        components: {InterModal, InterInput},
        data() {
            return {
                buttonPrimary: {
                    label: 'Salva',
                    confirm: true
                },
                passwords: {
                    old: '',
                    new: '',
                    confirm: ''
                },
                errors: {},
            }
        },
        props: {
            showModal: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.$emit('updateShowModal', false)
            });
            this.passwords = {
                old: '',
                new: '',
                confirm: ''
            };
        },
        methods: {
            ...mapActions({
                authUpdatePassword: 'authUpdatePassword',
            }),

            updatePassword: function () {
                if (this.validate()) {
                    this.authUpdatePassword(this.passwords)
                        .then(() => {
                            this.$bvToast.toast('Password aggiornata', {
                                title: 'Success',
                                variant: 'success'
                            });
                            this.$emit('updateShowModal', false)
                        })
                        .catch(() => {
                            this.$bvToast.toast('Password non aggiornate', {
                                title: 'Alert',
                                variant: 'warning'
                            });
                            this.$emit('updateShowModal', false)
                        })
                }
            },

            validate: function () {
                this.errors = {};
                if (this.passwords.old === '') {
                    this.errors.old = true;
                    this.$bvToast.toast('La password vecchia non può essere vuota', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                if (this.passwords.new === '') {
                    this.errors.new = true;
                    this.$bvToast.toast('La password nuova non può essere vuota', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                if (this.passwords.new !== this.passwords.confirm) {
                    this.errors.new = true;
                    this.errors.confirm = true;
                    this.$bvToast.toast('La password di conferma non corrisponde', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                return _.isEmpty(this.errors);
            }
        }

    }
</script>

<style scoped>

</style>
